import * as React from 'react';

/** The prototype's icon set (prototype/index.html, `IC`), path for path. */
type IconProps = { readonly size?: number; readonly strokeWidth?: number };

function Svg({ size = 18, strokeWidth = 1.8, children }: IconProps & { readonly children: React.ReactNode }): React.ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const TodayIcon = (): React.ReactElement => (
  <Svg>
    <rect x="3" y="4.5" width="18" height="16" rx="2.5" />
    <path d="M3 9.5h18M8 2.5v4M16 2.5v4" />
  </Svg>
);
export const PeopleIcon = (): React.ReactElement => (
  <Svg>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M17 14.5c2.3 0 4 1.4 4.5 4" />
  </Svg>
);
export const ProjectsIcon = (): React.ReactElement => (
  <Svg>
    <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" />
    <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
    <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" />
    <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" />
  </Svg>
);
export const TalosIcon = (): React.ReactElement => (
  <Svg>
    <rect x="4" y="7" width="16" height="12" rx="3" />
    <path d="M12 3v4M9 12.5v1.5M15 12.5v1.5M2 12v3M22 12v3" />
  </Svg>
);
export const InboxIcon = (): React.ReactElement => (
  <Svg>
    <path d="M3 13h5l1.5 3h5L16 13h5" />
    <path d="M5 5h14l2 8v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6z" />
  </Svg>
);
export const ShippedIcon = (): React.ReactElement => (
  <Svg>
    <path d="M12 3 3 7.5v9L12 21l9-4.5v-9z" />
    <path d="M3 7.5 12 12l9-4.5M12 12v9" />
  </Svg>
);
export const ReportsIcon = (): React.ReactElement => (
  <Svg>
    <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
    <path d="M14 3v6h6" />
    <path d="M8 13h8M8 17h5" />
  </Svg>
);
export const TrendsIcon = (): React.ReactElement => (
  <Svg>
    <path d="M3 20h18" />
    <path d="M5 16l5-5 3 3 6-7" />
  </Svg>
);
export const ArrowIcon = (): React.ReactElement => (
  <Svg size={14} strokeWidth={2}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </Svg>
);
export const BackIcon = (): React.ReactElement => (
  <Svg size={16} strokeWidth={2}>
    <path d="M15 5l-7 7 7 7" />
  </Svg>
);
export const AlertIcon = (): React.ReactElement => (
  <Svg size={16} strokeWidth={2}>
    <path d="M12 3.5 2.5 20h19L12 3.5z" />
    <path d="M12 10v4.5M12 17.5v.01" />
  </Svg>
);
export const ExternalIcon = (): React.ReactElement => (
  <Svg size={11} strokeWidth={2.2}>
    <path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />
  </Svg>
);
/** MS-6: a flag, for Milestones. */
export const MilestonesIcon = (): React.ReactElement => (
  <Svg>
    <path d="M5 21V4" />
    <path d="M5 4h11l-2 4 2 4H5" />
  </Svg>
);
export const CalendarIcon = (): React.ReactElement => (
  <Svg size={16}>
    <rect x="3" y="4.5" width="18" height="16" rx="2.5" />
    <path d="M3 9.5h18M8 2.5v4M16 2.5v4" />
  </Svg>
);
export const ChevronIcon = (): React.ReactElement => (
  <Svg size={14} strokeWidth={2}>
    <path d="M9 6l6 6-6 6" />
  </Svg>
);
/** The brand mark: a pulse line on the accent square. */
export const PulseMark = (): React.ReactElement => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 12h4.5l2.5-6 4 12 3-9 1.5 3H22" />
  </svg>
);
